import React from "react";
import { motion } from "framer-motion";

import {
  FaFacebookF,
  FaTwitter,
  FaEnvelope,
  FaQuoteLeft,
  FaGraduationCap,
  FaArrowRight,
  FaAward,
  FaBookOpen,
  FaHeart,
  FaStar,
  FaCheckCircle,
  FaUserGraduate,
} from "react-icons/fa";

import principalImage from "./royalfounder.png";
import Footer from "./Footer";

const PrincipalMessagePage = () => {
  const principalEmail = "principal@school.com";

  const styles = `
    .jana-principal-page {
      --jp-purple: #062db9;
      --jp-deep: #2a3bfe;
      --jp-dark: #0e0844;
      --jp-gold: #f4c542;
      --jp-gold-dark: #d6a817;
      --jp-text: #6a11fa;
      --jp-muted: #766e82;
      position: relative;
      isolation: isolate;
      overflow: hidden;
      padding: 82px 6% 100px;
      background:
        radial-gradient(ellipse at 0% 0%, rgba(84, 33, 143, 0.07), transparent 35%),
        linear-gradient(180deg, #ffffff 0%, #faf7ff 55%, #f7f1ff 100%);
      font-family: inherit;
    }

    .jana-principal-page *,
    .jana-principal-page *::before,
    .jana-principal-page *::after {
      box-sizing: border-box;
    }

    .jana-principal-page .jp-decoration {
      position: absolute;
      z-index: -1;
      border-radius: 50%;
      pointer-events: none;
    }

    .jana-principal-page .jp-decoration-one {
      top: 120px;
      right: -180px;
      width: 440px;
      height: 440px;
      border: 70px solid rgba(84, 33, 143, 0.045);
    }

    .jana-principal-page .jp-decoration-two {
      bottom: 80px;
      left: -150px;
      width: 310px;
      height: 310px;
      border: 55px solid rgba(244, 197, 66, 0.13);
    }

    .jana-principal-inner {
      max-width: 1330px;
      margin: 0 auto;
    }

    .jana-principal-heading {
      max-width: 830px;
      margin: 0 auto 60px;
      text-align: center;
    }

    .jana-principal-eyebrow {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 9px;
      padding: 10px 17px;
      border: 1px solid rgba(84, 33, 143, 0.13);
      border-radius: 50px;
      background: #f1e9fc;
      color: var(--jp-purple);
      font-size: 10px;
      font-weight: 850;
      letter-spacing: 1.7px;
      text-transform: uppercase;
    }

    .jana-principal-eyebrow svg {
      color: #b58a15;
      font-size: 13px;
    }

    .jana-principal-heading h1 {
      margin: 23px 0 18px;
      color: var(--jp-deep);
      font-size: clamp(35px, 5vw, 59px);
      font-weight: 900;
      line-height: 1.12;
      letter-spacing: -1.8px;
    }

    .jana-principal-heading h1 span {
      display: block;
      margin-top: 8px;
      color: var(--jp-purple);
    }

    .jana-principal-heading > p {
      max-width: 690px;
      margin: 0 auto;
      color: var(--jp-muted);
      font-size: 14px;
      line-height: 1.95;
    }

    .jana-principal-heading-accent {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 7px;
      margin-top: 24px;
    }

    .jana-principal-heading-accent span {
      display: block;
      height: 4px;
      border-radius: 10px;
      background: var(--jp-gold);
    }

    .jana-principal-heading-accent span:first-child,
    .jana-principal-heading-accent span:last-child {
      width: 25px;
      opacity: 0.6;
    }

    .jana-principal-heading-accent span:nth-child(2) {
      width: 55px;
      background: var(--jp-purple);
    }

    .jana-principal-layout {
      display: grid;
      grid-template-columns: minmax(290px, 0.82fr) minmax(0, 1.5fr);
      align-items: start;
      gap: 35px;
    }

    /* PRINCIPAL PROFILE */

    .jana-principal-profile {
      position: relative;
      min-width: 0;
      overflow: hidden;
      border: 1px solid rgba(84, 33, 143, 0.12);
      border-radius: 25px;
      background: #ffffff;
      box-shadow: 0 18px 55px rgba(53, 16, 95, 0.1);
    }

    .jana-principal-profile-top {
      position: relative;
      padding: 15px 15px 0;
      background: linear-gradient(140deg, #54218f, #35105f);
    }

    .jana-principal-profile-top::before {
      content: "";
      position: absolute;
      top: -70px;
      right: -45px;
      width: 190px;
      height: 190px;
      border: 30px solid rgba(255, 255, 255, 0.065);
      border-radius: 50%;
      pointer-events: none;
    }

    .jana-principal-photo-frame {
      position: relative;
      height: 385px;
      overflow: hidden;
      border: 3px solid rgba(244, 197, 66, 0.85);
      border-radius: 18px 18px 4px 4px;
      background: #e9def7;
    }

    .jana-principal-photo {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center top;
      transition: transform 0.6s ease;
    }

    .jana-principal-profile:hover .jana-principal-photo {
      transform: scale(1.035);
    }

    .jana-principal-role-badge {
      position: absolute;
      right: 12px;
      bottom: 12px;
      left: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 9px;
      padding: 13px 12px;
      border: 1px solid rgba(255, 255, 255, 0.35);
      border-radius: 10px;
      background: var(--jp-gold);
      color: var(--jp-deep);
      font-size: 11px;
      font-weight: 900;
      letter-spacing: 0.7px;
      text-align: center;
      text-transform: uppercase;
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);
    }

    .jana-principal-role-badge svg {
      font-size: 15px;
    }

    .jana-principal-profile-content {
      padding: 27px 25px 26px;
      text-align: center;
    }

    .jana-principal-profile-label {
      display: inline-block;
      margin-bottom: 10px;
      color: #a27b18;
      font-size: 10px;
      font-weight: 850;
      letter-spacing: 1.5px;
      text-transform: uppercase;
    }

    .jana-principal-profile-content h2 {
      margin: 0;
      color: var(--jp-deep);
      font-size: 25px;
      font-weight: 900;
      line-height: 1.35;
      letter-spacing: -0.5px;
    }

    .jana-principal-profile-position {
      margin: 8px 0 0;
      color: var(--jp-purple);
      font-size: 13px;
      font-weight: 750;
    }

    .jana-principal-profile-divider {
      width: 45px;
      height: 3px;
      margin: 21px auto;
      border-radius: 10px;
      background: var(--jp-gold);
    }

    .jana-principal-profile-description {
      margin: 0;
      color: var(--jp-muted);
      font-size: 12.5px;
      line-height: 1.9;
    }

    .jana-principal-socials {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      margin-top: 23px;
      padding-top: 21px;
      border-top: 1px solid #f0eaf6;
    }

    .jana-principal-social-link {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border: 1px solid #eae1f4;
      border-radius: 12px;
      background: #f7f2fd;
      color: var(--jp-purple);
      font-size: 15px;
      text-decoration: none;
      transition:
        color 0.25s ease,
        background 0.25s ease,
        transform 0.25s ease;
    }

    .jana-principal-social-link:hover {
      transform: translateY(-3px);
      background: var(--jp-purple);
      color: var(--jp-gold);
    }

    /* PRINCIPAL'S MESSAGE */

    .jana-principal-message {
      position: relative;
      min-width: 0;
      padding: 42px 42px 36px;
      overflow: hidden;
      border: 1px solid #eee5f7;
      border-radius: 25px;
      background: #ffffff;
      box-shadow: 0 18px 55px rgba(53, 16, 95, 0.075);
    }

    .jana-principal-message::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 5px;
      background: linear-gradient(
        90deg,
        var(--jp-purple),
        var(--jp-gold),
        var(--jp-purple)
      );
    }

    .jana-principal-message-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 15px;
      margin-bottom: 30px;
    }

    .jana-principal-message-label {
      display: inline-flex;
      align-items: center;
      gap: 9px;
      color: var(--jp-purple);
      font-size: 10px;
      font-weight: 900;
      letter-spacing: 1.5px;
      text-transform: uppercase;
    }

    .jana-principal-message-label svg {
      color: #bd941f;
      font-size: 14px;
    }

    .jana-principal-message-number {
      color: #eee7f6;
      font-size: 36px;
      font-weight: 900;
      line-height: 1;
      letter-spacing: -1px;
    }

    .jana-principal-quote-mark {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 62px;
      height: 62px;
      margin-bottom: 23px;
      border: 1px solid rgba(84, 33, 143, 0.1);
      border-radius: 18px;
      background: #f2eafb;
      color: var(--jp-purple);
      font-size: 25px;
    }

    .jana-principal-message h2 {
      margin: 0 0 24px;
      color: var(--jp-deep);
      font-size: clamp(27px, 3vw, 38px);
      font-weight: 900;
      line-height: 1.23;
      letter-spacing: -1px;
    }

    .jana-principal-message h2 span {
      color: var(--jp-purple);
    }

    .jana-principal-message-body {
      display: grid;
      gap: 17px;
    }

    .jana-principal-message-body p {
      margin: 0;
      color: #696174;
      font-size: 13.5px;
      line-height: 2;
    }

    .jana-principal-message-body .jana-principal-opening {
      padding-left: 17px;
      border-left: 3px solid var(--jp-gold);
      color: #473b58;
      font-size: 15px;
      font-weight: 650;
      line-height: 1.9;
    }

    .jana-principal-values {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 11px;
      margin-top: 30px;
      padding: 23px 0;
      border-top: 1px solid #f0eaf6;
      border-bottom: 1px solid #f0eaf6;
    }

    .jana-principal-value {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      min-width: 0;
    }

    .jana-principal-value-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 34px;
      flex-shrink: 0;
      border-radius: 10px;
      background: #f2eafb;
      color: var(--jp-purple);
      font-size: 14px;
    }

    .jana-principal-value strong {
      display: block;
      margin: 2px 0 5px;
      color: var(--jp-deep);
      font-size: 11px;
      font-weight: 850;
      line-height: 1.4;
    }

    .jana-principal-value span {
      display: block;
      color: var(--jp-muted);
      font-size: 10px;
      line-height: 1.65;
    }

    .jana-principal-signoff {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      gap: 20px;
      margin-top: 29px;
    }

    .jana-principal-signoff-copy {
      min-width: 0;
    }

    .jana-principal-signoff-label {
      display: block;
      margin-bottom: 8px;
      color: var(--jp-muted);
      font-size: 11px;
    }

    .jana-principal-signature {
      color: var(--jp-purple);
      font-family: Georgia, "Times New Roman", serif;
      font-size: 24px;
      font-style: italic;
      font-weight: 700;
      line-height: 1.3;
      overflow-wrap: anywhere;
    }

    .jana-principal-signoff-role {
      display: block;
      margin-top: 5px;
      color: var(--jp-deep);
      font-size: 11px;
      font-weight: 850;
    }

    .jana-principal-contact-button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      min-height: 45px;
      padding: 0 17px;
      flex-shrink: 0;
      border: 0;
      border-radius: 10px;
      background: var(--jp-purple);
      color: #ffffff;
      font: inherit;
      font-size: 11px;
      font-weight: 850;
      text-decoration: none;
      transition:
        background 0.25s ease,
        transform 0.25s ease;
    }

    .jana-principal-contact-button:hover {
      transform: translateY(-2px);
      background: var(--jp-deep);
      color: var(--jp-gold);
    }

    .jana-principal-contact-button svg {
      color: var(--jp-gold);
    }

    .jana-principal-bottom-banner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 25px;
      margin-top: 35px;
      padding: 29px 32px;
      border-radius: 19px;
      background: linear-gradient(115deg, #35105f, #54218f);
      box-shadow: 0 15px 35px rgba(53, 16, 95, 0.14);
    }

    .jana-principal-bottom-copy {
      display: flex;
      align-items: center;
      gap: 17px;
      min-width: 0;
    }

    .jana-principal-bottom-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 51px;
      height: 51px;
      flex-shrink: 0;
      border-radius: 15px;
      background: rgba(244, 197, 66, 0.15);
      color: var(--jp-gold);
      font-size: 23px;
    }

    .jana-principal-bottom-copy h3 {
      margin: 0 0 6px;
      color: #ffffff;
      font-size: 16px;
      font-weight: 850;
      line-height: 1.5;
    }

    .jana-principal-bottom-copy p {
      margin: 0;
      color: rgba(255, 255, 255, 0.76);
      font-size: 12px;
      line-height: 1.8;
    }

    .jana-principal-bottom-badge {
      display: inline-flex;
      align-items: center;
      gap: 9px;
      padding: 12px 16px;
      flex-shrink: 0;
      border: 1px solid rgba(244, 197, 66, 0.3);
      border-radius: 10px;
      background: rgba(244, 197, 66, 0.1);
      color: var(--jp-gold);
      font-size: 11px;
      font-weight: 850;
    }

    @media (max-width: 1100px) {
      .jana-principal-page {
        padding: 75px 5% 80px;
      }

      .jana-principal-layout {
        grid-template-columns: minmax(260px, 0.75fr) minmax(0, 1.25fr);
        gap: 23px;
      }

      .jana-principal-message {
        padding: 33px 28px 29px;
      }

      .jana-principal-photo-frame {
        height: 340px;
      }

      .jana-principal-values {
        grid-template-columns: 1fr;
        gap: 14px;
      }
    }

    @media (max-width: 800px) {
      .jana-principal-layout {
        grid-template-columns: minmax(0, 1fr);
        max-width: 650px;
        margin: 0 auto;
      }

      .jana-principal-profile {
        max-width: 480px;
        width: 100%;
        margin: 0 auto;
      }

      .jana-principal-photo-frame {
        height: 420px;
      }

      .jana-principal-values {
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }

      .jana-principal-bottom-banner {
        align-items: flex-start;
        flex-direction: column;
      }
    }

    @media (max-width: 550px) {
      .jana-principal-page {
        padding: 58px 5% 65px;
      }

      .jana-principal-heading {
        margin-bottom: 37px;
      }

      .jana-principal-heading h1 {
        font-size: 35px;
        letter-spacing: -1px;
      }

      .jana-principal-heading > p {
        font-size: 13px;
      }

      .jana-principal-photo-frame {
        height: 350px;
      }

      .jana-principal-profile-content {
        padding: 24px 20px;
      }

      .jana-principal-message {
        padding: 27px 21px 24px;
        border-radius: 19px;
      }

      .jana-principal-message h2 {
        font-size: 29px;
      }

      .jana-principal-message-body p {
        font-size: 12.5px;
      }

      .jana-principal-values {
        grid-template-columns: minmax(0, 1fr);
      }

      .jana-principal-signoff {
        align-items: stretch;
        flex-direction: column;
      }

      .jana-principal-contact-button {
        width: 100%;
      }

      .jana-principal-bottom-banner {
        padding: 24px 20px;
      }

      .jana-principal-bottom-copy {
        align-items: flex-start;
        gap: 12px;
      }

      .jana-principal-bottom-copy h3 {
        font-size: 14px;
      }

      .jana-principal-bottom-badge {
        align-self: flex-start;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .jana-principal-photo,
      .jana-principal-social-link,
      .jana-principal-contact-button {
        transition: none !important;
      }
    }
  `;

  return (
    <>
      <style>{styles}</style>

      <main className="jana-principal-page">
        <div
          className="jp-decoration jp-decoration-one"
          aria-hidden="true"
        />

        <div
          className="jp-decoration jp-decoration-two"
          aria-hidden="true"
        />

        <div className="jana-principal-inner">
          {/* PAGE INTRODUCTION */}
          <motion.header
            className="jana-principal-heading"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.65 }}
            viewport={{ once: true, amount: 0.2 }}
          >
            <span className="jana-principal-eyebrow">
              <FaGraduationCap aria-hidden="true" />
              A Message from Our Leadership
            </span>

            <h1>
              Leading With Purpose.
              <span>Inspiring Every Learner.</span>
            </h1>

            <p>
              A personal welcome from our principal, sharing our
              commitment to quality education, strong character,
              responsible leadership, and the success of every student.
            </p>

            <div
              className="jana-principal-heading-accent"
              aria-hidden="true"
            >
              <span />
              <span />
              <span />
            </div>
          </motion.header>

          <div className="jana-principal-layout">
            {/* PRINCIPAL PROFILE */}
            <motion.aside
              className="jana-principal-profile"
              initial={{ opacity: 0, x: -45 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.75, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.15 }}
            >
              <div className="jana-principal-profile-top">
                <div className="jana-principal-photo-frame">
                  <img
                    src={principalImage}
                    alt="Our school principal"
                    className="jana-principal-photo"
                    loading="lazy"
                  />

                  <div className="jana-principal-role-badge">
                    <FaGraduationCap aria-hidden="true" />
                    Principal &amp; Founder
                  </div>
                </div>
              </div>

              <div className="jana-principal-profile-content">
                <span className="jana-principal-profile-label">
                  School Leadership
                </span>

                <h2>Our Principal</h2>

                <p className="jana-principal-profile-position">
                  Academic Leadership &amp; Student Development
                </p>

                <div
                  className="jana-principal-profile-divider"
                  aria-hidden="true"
                />

                <p className="jana-principal-profile-description">
                  Dedicated to fostering academic excellence,
                  developing good character, and creating a school
                  community where every learner has the opportunity
                  to grow and succeed.
                </p>

                <div
                  className="jana-principal-socials"
                  aria-label="Principal contact links"
                >
                  <a
                    href={`mailto:${principalEmail}`}
                    className="jana-principal-social-link"
                    aria-label="Email the principal"
                    title="Email the principal"
                  >
                    <FaEnvelope aria-hidden="true" />
                  </a>

                  <a
                    href="#home"
                    className="jana-principal-social-link"
                    aria-label="Visit the school home section"
                    title="School home"
                  >
                    <FaGraduationCap aria-hidden="true" />
                  </a>
                </div>
              </div>
            </motion.aside>

            {/* MESSAGE CONTENT */}
            <motion.article
              className="jana-principal-message"
              initial={{ opacity: 0, x: 45 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.75, ease: "easeOut", delay: 0.08 }}
              viewport={{ once: true, amount: 0.12 }}
            >
              <div className="jana-principal-message-top">
                <span className="jana-principal-message-label">
                  <FaStar aria-hidden="true" />
                  A Personal Welcome
                </span>

                <span
                  className="jana-principal-message-number"
                  aria-hidden="true"
                >
                  01
                </span>
              </div>

              <div className="jana-principal-quote-mark">
                <FaQuoteLeft aria-hidden="true" />
              </div>

              <h2>
                Welcome to Our School,
                <span> Where Every Learner Matters.</span>
              </h2>

              <div className="jana-principal-message-body">
                <p className="jana-principal-opening">
                  Welcome to our esteemed school, a place where young
                  minds are nurtured, potential is discovered, and
                  every student is encouraged to achieve their best.
                </p>

                <p>
                  As principal, I take immense pride in the dedication
                  of our teachers, the enthusiasm of our students, and
                  the unwavering support of our parents and community.
                  Together, these partnerships create the foundation
                  for a meaningful and successful educational journey.
                </p>

                <p>
                  Our mission is to provide a balanced education that
                  extends beyond the classroom. We emphasize academic
                  excellence, character development, creativity,
                  discipline, and leadership so our students can face
                  future opportunities with confidence and integrity.
                </p>

                <p>
                  We recognize that every student is unique, with
                  individual strengths, interests, and aspirations.
                  Through quality teaching, innovation, compassion,
                  and a supportive learning environment, we strive to
                  help every learner discover their abilities and
                  reach their full potential.
                </p>

                <p>
                  I warmly invite parents, guardians, and members of
                  our community to partner with us in this important
                  mission. Together, we can inspire achievement,
                  strengthen values, and prepare our young people for
                  a brighter future.
                </p>
              </div>

              {/* CORE EDUCATIONAL VALUES */}
              <div className="jana-principal-values">
                <div className="jana-principal-value">
                  <div className="jana-principal-value-icon">
                    <FaAward aria-hidden="true" />
                  </div>

                  <div>
                    <strong>Excellence</strong>
                    <span>Encouraging every learner to achieve.</span>
                  </div>
                </div>

                <div className="jana-principal-value">
                  <div className="jana-principal-value-icon">
                    <FaHeart aria-hidden="true" />
                  </div>

                  <div>
                    <strong>Character</strong>
                    <span>Building respect, integrity, and care.</span>
                  </div>
                </div>

                <div className="jana-principal-value">
                  <div className="jana-principal-value-icon">
                    <FaBookOpen aria-hidden="true" />
                  </div>

                  <div>
                    <strong>Lifelong Learning</strong>
                    <span>Preparing students for future success.</span>
                  </div>
                </div>
              </div>

              {/* SIGNATURE AND CONTACT */}
              <div className="jana-principal-signoff">
                <div className="jana-principal-signoff-copy">
                  <span className="jana-principal-signoff-label">
                    With warm regards,
                  </span>

                  <div className="jana-principal-signature">
                    Our Principal
                  </div>

                  <span className="jana-principal-signoff-role">
                    Principal &amp; School Leadership
                  </span>
                </div>

                <a
                  href={`mailto:${principalEmail}`}
                  className="jana-principal-contact-button"
                >
                  Contact the Principal
                  <FaArrowRight aria-hidden="true" />
                </a>
              </div>
            </motion.article>
          </div>

          {/* BOTTOM MESSAGE */}
          <motion.div
            className="jana-principal-bottom-banner"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.65 }}
            viewport={{ once: true, amount: 0.2 }}
          >
            <div className="jana-principal-bottom-copy">
              <div className="jana-principal-bottom-icon">
                <FaUserGraduate aria-hidden="true" />
              </div>

              <div>
                <h3>Together, We Build a Brighter Future</h3>

                <p>
                  Every student deserves the opportunity to learn,
                  grow, lead, and make a difference.
                </p>
              </div>
            </div>

            <div className="jana-principal-bottom-badge">
              <FaCheckCircle aria-hidden="true" />
              Learning • Character • Excellence
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default PrincipalMessagePage;
